import { Injectable } from '@angular/core';

@Injectable()
export class UpdateDataService {

  constructor() { }

  chackUpdateValue(inputObj: any, outputObj: any, exapt?: string, exapt1?: string) {
    try {
      let changes = {};
      let changesArr = [];
      let arr = false;

      if (typeof (inputObj) == 'undefined' && typeof (outputObj) == 'undefined' || inputObj == null && outputObj == null) {
        return;
      }

      if (typeof (inputObj) == 'undefined' && typeof (outputObj) == 'string' || inputObj == null && outputObj != null) {
        changes = outputObj;
        return changes;
      }

      if (Array.isArray(outputObj)) {
        outputObj.forEach((item, index) => {
          if (typeof item == 'object') {
            changesArr[index] = this.chackUpdateValue(inputObj[index], outputObj[index], exapt, exapt1);
          } else {
            if (!~inputObj.indexOf(item) || inputObj.length != outputObj.length) {
              if (arr) {
                return;
              }
              arr = true;
            }
          }
        });
        if (arr) {
          return outputObj;
        } else {
          return changesArr;
        }
      } else if (typeof (inputObj) == 'object') {
        Object.keys(inputObj).forEach(key => {

          if (outputObj[key]) {
            changes[key] = this.chackUpdateValue(inputObj[key], outputObj[key], exapt, exapt1);
          }

          if (key == exapt || key == exapt1) {
            changes[key] = outputObj[key];
          } else if (JSON.stringify(changes[key]) == '{}') {
            delete changes[key];
          } else if (Array.isArray(changes[key]) && changes[key].length == 0 && inputObj[key].length > 0 && outputObj[key].length > 0 ||
            Array.isArray(changes[key]) && changes[key].length == 0 && inputObj[key].length == 0 && outputObj[key].length == 0 ||
            typeof (inputObj[key]) == 'undefined' && typeof (outputObj[key]) == 'undefined' ||
            inputObj[key] == null && outputObj[key] == null) {

            delete changes[key];
          }
        });

      } else {
        if (inputObj != outputObj) {
          changes = outputObj;
        }
      }

      return changes;

    }
    catch (ex) {      
      console.log('​UpdateDataService -> catch -> ',ex );
      return outputObj;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/update-data.service.ts